// extracted by mini-css-extract-plugin
export default {"preApprovalDocuments":"styles_preApprovalDocuments__DDBJ6","uploadDate":"styles_uploadDate__Gda7+"};